import { ArrowLeft } from "lucide-react";

/**
 * TopBar — DISABLED per user iter M637.
 *
 * The user reported the fixed top bar (with HOME/BACK buttons) was
 * occluding page content.  Rather than remove every <TopBar /> call
 * site we just make the component render nothing.  Navigation is
 * fully covered by the left-rail NavPane (visible on every page) and
 * the global mute toggle in the top-right corner is mounted at the
 * App root.  Re-enabling the bar later is a one-line change.
 */
// eslint-disable-next-line no-unused-vars
export const TopBar = (_props) => null;

export default TopBar;

